import "../Main.scss";
import { MdHomeFilled, MdKeyboardArrowRight } from "react-icons/md";
import { SiMicrosoftexcel } from "react-icons/si";
import "./Breakdown.scss";
import { Link, Outlet, useNavigate } from "react-router-dom";
function My() {
  let navigate = useNavigate();
  return (
    <>
      <div className=" location_wrap">
        <div className="location">
          <Link to="/">
            <MdHomeFilled />
          </Link>
          <MdKeyboardArrowRight />
          <Link to="/breakdown/cits">나의 신청내역</Link>
        </div>
      </div>

      <div className="contain my_wrap">
        <form className="my_page" action="" method="">
          <div className="my_page_heading mybreakdown">
            <div className="my_page_heading_inner mybreakdown_inner">
              <Link to="/my">마이페이지</Link>
              <Link className="active_tab" to="/breakdown/cits">
                나의 신청내역
              </Link>
              <Link to="/succession">지위승계</Link>
            </div>
          </div>

          <section className="row">
            <div className="col">
              <Outlet></Outlet>
            </div>
          </section>
        </form>
      </div>
    </>
  );
}

export default My;
